module.exports = __webpack_public_path__ + "static/media/mloader.076282eb.gif";